import { ApolloQueryResult } from 'apollo-client';

import { clientDevQuery } from '../../graphql/queries/grid/clientDev';
import { ClientDevData } from '../../typings/dev';
import { ClientDevQuery } from '../../typings/graphql-grid';
import { BaseDataProvider } from '../BaseDataProvider/BaseDataProvider';

export class ClientDevProvider extends BaseDataProvider {
    public fetchClientDev = (): Promise<ClientDevData> => {
        return this.createQuery<ClientDevQuery>(clientDevQuery).then(
            (result: ApolloQueryResult<ClientDevQuery>): ClientDevData => {
                return {
                    clientId: result.data.clientDev.clientId,
                    configuration: result.data.clientDev.environment,
                    operatorLogin: result.data.clientDev.operatorLogin,
                    role: String(result.data.clientDev.role),
                    shard: String(result.data.clientDev.shard),
                    uid: result.data.clientDev.uid,
                    operatorFeatures: result.data.clientDev.operatorFeatures || [],
                    clientFeatures: result.data.clientDev.clientFeatures || []
                };
            }
        );
    };
}
